import { Link, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck, Users } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (!user || user === false) return null;

  const initials = (user.name || user.email || "?")
    .split(/\s+/)
    .map((s) => s[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-30 backdrop-blur-xl bg-envicom-bg/85 border-b border-envicom-border"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-brand" className="flex items-center gap-3">
          <img
            src="/cme-logo.png"
            alt="CME"
            className="h-8 w-auto"
            style={{ filter: "brightness(1.1)" }}
          />
          <div className="hidden sm:block w-px h-6 bg-envicom-border" />
          <div className="font-mono leading-tight">
            <div className="text-envicom-text text-base font-bold tracking-tight">enviCoM 4.0</div>
            <div className="text-envicom-muted text-[10px] uppercase tracking-[0.18em]">Engineer Portal</div>
          </div>
        </Link>

        <div className="flex items-center gap-2 sm:gap-4">
          {user.role === "super_admin" && (
            <button
              type="button"
              onClick={() => navigate("/admin/users")}
              data-testid="header-admin-users-btn"
              className="hidden sm:inline-flex items-center gap-2 px-3 py-1.5 rounded border border-envicom-border text-envicom-muted hover:text-envicom-text hover:border-envicom-borderHover transition-colors text-sm font-mono"
            >
              <Users className="w-4 h-4" /> Users
            </button>
          )}
          <div className="flex items-center gap-3 pl-2 sm:pl-4 sm:border-l sm:border-envicom-border">
            <div className="w-9 h-9 rounded-full bg-envicom-surface border border-envicom-border flex items-center justify-center font-mono text-xs text-envicom-text">
              {initials}
            </div>
            <div className="hidden md:flex flex-col leading-tight">
              <span data-testid="header-user-name" className="text-envicom-text text-sm font-medium">
                {user.name}
              </span>
              <span className="text-envicom-muted text-[11px] flex items-center gap-1 font-mono uppercase tracking-wider">
                {user.role === "super_admin" ? <ShieldCheck className="w-3 h-3 text-envicom-accent" /> : null}
                {user.role.replace("_", " ")}
              </span>
            </div>
            <button
              type="button"
              onClick={async () => {
                await logout();
                navigate("/login");
              }}
              data-testid="header-logout-btn"
              className="inline-flex items-center gap-2 px-3 py-1.5 rounded text-envicom-muted hover:text-envicom-error transition-colors text-sm font-mono"
            >
              <LogOut className="w-4 h-4" /> Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
